import { TimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from "@date-io/date-fns";
import React, { useState }  from 'react';


const AddHoliday = ({ handleDetailsSidebar, details }) => {

    const [selectedDate, handleDateChange] = useState(new Date());

    return (
        <div className='addHoliday'>
            
            <div className={details ? "holidayDetailsActive" : "holidayDetails"}>
                <div className="top-portion d-flex justify-content-start align-items-center">
                    <span onClick={() => handleDetailsSidebar("close")}><i className="bi bi-arrow-left ms-4 me-3"></i></span>
                    <span>Add Holiday or Special Hours</span>
                </div>
                
                <div className="card rounded-0 h-card">
                    <div className="card-header rounded-0 add-holiday-card">
                        <b>Holidays and Special Hours</b>
                    </div>
                    <div className="card-body">
                        <span>Please indicate when your restaurant will be closed or have different hours  than usual.</span>
                        <div className="row w-100 mt-3">
                            <div className="col-md-6 col-lg-6">
                                <div>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <TimePicker
                                            autoOk
                                            label=""
                                            value={selectedDate}
                                            onChange={handleDateChange}
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>
                                <small>From</small>
                            </div>
                            <div className="col-md-6 col-lg-6">
                                <div>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <TimePicker
                                            autoOk
                                            label=""
                                            value={selectedDate}
                                            onChange={handleDateChange}
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>
                                <small>To</small>
                            </div>
                        </div>

                        <small className='mt-4 d-block'> <b>Will you be close the whole day? </b>  </small>

                        <div className="d-flex d-block mt-2">
                            <div className='d-flex justify-content-center'>
                                <input type="radio" id='yes' />
                                <label htmlFor="yes" className='ml-1'>Yes</label>
                            </div>
                            <div className="ml-2 d-flex justify-content-center">
                                <input type="radio" id='no' />
                                <label htmlFor="no" className='ml-1'>No</label>
                            </div>
                        </div>
                      
                       

                    </div>
                </div>

               
            </div>
            
        </div>
    );
};

export default AddHoliday;